import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import moment from "moment";
import {
  Block,
  BlockHead,
  Icon,
  PaginationComponent,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
} from "components/Component";
import Content from "layout/content/Content";
import Head from "layout/head/Head";

import { Card } from "reactstrap";
import { Link } from "react-router-dom";
import ReactDatePicker from "react-datepicker";
import { getDashboardCustomerLeadProspect } from "../../services/dashboard";

const CustomerLeadsOpen = (props) => {
  const [cookies] = useCookies(["user"]);
  const { selectedDepartment } = props;
  const [data, setData] = useState(null);
  const [startDate, setStartDate] = useState(new Date(moment().subtract(1, "months").format("YYYY-MM-DD")));
  const [endDate, setEndDate] = useState(new Date(moment().format("YYYY-MM-DD")));
  const [sort] = useState(false);
  const [metaData, setMetaData] = useState({
    itemCount: 0,
    page: 0,
    take: 0,
    pageCount: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });
  const [page] = useState(1);
  const [take] = useState(10);

  const getDataLeadsOpen = async (page) => {
    //console.log("cookies.SIDikey", cookies.id);
    const sortData = sort ? "ASC" : "DESC";
    const responseGetDataLeadsOpen = await getDashboardCustomerLeadProspect(
      sortData,
      cookies.SIDikey,
      page,
      take,
      cookies.id,
      moment(startDate).format("YYYY-MM-DD"),
      moment(endDate).format("YYYY-MM-DD"),
      cookies.role.name,
      selectedDepartment.value
    );
    setData(responseGetDataLeadsOpen.data.data);
    setMetaData(responseGetDataLeadsOpen.data.meta);
  };

  useEffect(() => {
    getDataLeadsOpen(page, startDate, endDate);
  }, [startDate, endDate, sort, selectedDepartment]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (start && end) {
      getDataLeadsOpen(page, start, end);
    }
  };

  const paginate = (pageNumber) => getDataLeadsOpen(pageNumber);

  return (
    <Card className="card-full">
      <Head title="Home"></Head>
      <Content>
        <BlockHead size="sm">
          <div className="d-flex justify-content-between w-100">
            <div className="card-title">
              <h6 className="title">Customer Leads Open</h6>
            </div>
            <div className="position-relative w-20 d-flex justify-content-center align-items-center">
              <ReactDatePicker
                className="w-100"
                selectsRange
                selected={startDate}
                startDate={startDate}
                endDate={endDate}
                onChange={handleDate}
                dateFormat={"yyyy-MM-dd"}
              />
              {/* <Icon name="download-cloud" className="custom-dropzone-text ml-3 "/> */}
              <Link to="/ticket?ticketStatus=OPENED">
                <p
                  className="text-blue"
                  style={{ whiteSpace: "nowrap", marginLeft: "10px", fontSize: "14px", cursor: "pointer" }}
                >
                  See More
                </p>
              </Link>
            </div>
          </div>
        </BlockHead>
        <Block>
          <DataTable className="card-stretch">
            <DataTableBody>
              <DataTableHead>
                <DataTableRow className="">
                  <span className="text">No</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="text">Customer Name</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="text">Last Chat </span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="text">Last Chat at</span>
                  {/* <Button
                    size="xs"
                    id="ticketId"
                    onClick={(ev) => {
                      setSort(!sort);
                    }}
                  >
                    <Icon name="sort" />
                  </Button> */}
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="text">Follow Up Date</span>
                </DataTableRow>
              </DataTableHead>
              {/*Head*/}
              {data?.length > 0
                ? data.map((item, i) => {
                    //console.log("item", item);
                    return (
                      <DataTableItem key={item.id}>
                        <DataTableRow size="mb">
                          <span className="tb-amount">{i + 1}</span>
                        </DataTableRow>
                        <DataTableRow size="md">
                          <span className="tb-amount">{item?.chat?.name}</span>
                        </DataTableRow>

                        <DataTableRow size="md">
                          <span style={{ display: "flex" }}>
                            "
                            <span className="tb-amount text-ellipsis" style={{ maxWidth: 400 }}>
                              {item?.chat?.lastMessage?.text}
                            </span>
                            "
                            <Link
                              href="/chat-platform"
                              to={"/chat-platform?chatID=" + item?.chat?.id}
                              style={{ marginLeft: 4 }}
                            >
                              <Icon className="text-blue" name="external" />
                            </Link>
                          </span>
                        </DataTableRow>
                        <DataTableRow size="md">
                          <span className="tb-amount">{moment(item?.chat?.lastMessage?.createdAt).format("LLL")}</span>
                        </DataTableRow>
                        <DataTableRow size="md">
                          <span className="tb-amount">
                            {item?.chat?.contact?.followUpDate !== null
                              ? moment(item?.chat?.contact?.followUpDate).format("YYYY-MM-DD")
                              : ""}
                          </span>
                        </DataTableRow>
                      </DataTableItem>
                    );
                  })
                : null}
            </DataTableBody>
            <div className="my-4 d-flex justify-content-end">
              {
                data?.length > 0 ? (
                  <PaginationComponent
                    itemPerPage={metaData?.take}
                    totalItems={metaData?.itemCount}
                    paginate={paginate}
                    currentPage={metaData?.page}
                  />
                ) : null
                // (
                //   <div className="text-center">
                //     <span className="text-silent">No data found</span>
                //   </div>
                // )
              }
            </div>
          </DataTable>
        </Block>
      </Content>
    </Card>
  );
};
export default CustomerLeadsOpen;
